export enum CommonErrors {
  // Connection Errors
  CommonError = '5l6W',
  ConnectionErrorTitle = 'hpec',
  ConnectionErrorMessage = 'NE9b',

  // Permission Errors
  NoPermitted = 'NQXl',
  NoPermittedForTransfer = '/8a/',

  // Validation Errors
  NotFound404 = 'fQT3',
  InvalidUrlMsg = 'YQl5',
  FieldIsRequired = 'RAjn',
  LengthMoreThen = 'A4so',
  LengthLessThen = 'iWE+',
}
